<template>
  <div class="v-editor d-flex mb-4">
    <v-icon v-if="icon" class="align-self-start mt-3 mr-2">{{ icon }}</v-icon>
    <v-card :dark="dark">
      <v-card-title class="accent">
        <div class="title white--text">{{ title }}</div>
      
        <editor-menu-bar :editor="editor">
          <!-- <div class="menubar" slot-scope="{ commands, isActive }"> -->
          <v-toolbar prominent color="transparent" :class="{ [`menubar ${extraclass}`]: true }" slot-scope="{ commands, isActive }">
            <v-btn
              flat
              small
              outline
              icon
              class="control__text"
              :class="{ 'is-active accent': isActive.bold() }"
              title="Negrita (Ctrl + B)"
              @click="commands.bold"
            >
              <v-icon>format_bold</v-icon>
            </v-btn>

            <!-- <v-btn
              flat
              small
              outline
              icon
              class="control__text"
              :class="{ 'is-active accent': isActive.italic() }"
              title="Cursiva (Ctrl + I)"
              @click="commands.italic"
            >
              <v-icon>format_italic</v-icon>
            </v-btn> -->

            <!-- <v-btn
              flat
              small
              outline
              icon
              class="control__text"
              :class="{ 'is-active accent': isActive.strike() }"
              title="Tachar"
              @click="commands.strike"
            >
              <v-icon>format_strikethrough</v-icon>
            </v-btn> -->

            <!-- <v-btn
              flat
              small
              outline
              icon
              class="control__text"
              :class="{ 'is-active accent': isActive.underline() }"
              title="Subrayado (Ctrl + U)"
              @click="commands.underline"
            >
              <v-icon>format_underlined</v-icon>
            </v-btn> -->

            <!-- <v-btn
              flat
              small
              outline
              icon
              class="control__text"
              :class="{ 'is-active accent': isActive.code() }"
              title="Código"
              @click="commands.code"
            >
              <v-icon>code</v-icon>
            </v-btn> -->

            <!-- <v-btn
              flat
              small
              outline
              icon
              class="control__text"
              :class="{ 'is-active accent': isActive.paragraph() }"
              title="Borrar formato"
              @click="commands.paragraph"
            >
              <v-icon>format_clear</v-icon>
            </v-btn> -->

            <v-btn
              flat
              small
              outline
              icon
              class="control__text"
              :class="{ 'is-active accent': isActive.heading({ level: 1 }) }"
              title="Título 1"
              @click="commands.heading({ level: 1 })"
            >H1</v-btn>

            <v-btn
              flat
              small
              outline
              icon
              class="control__text"
              :class="{ 'is-active accent': isActive.heading({ level: 2 }) }"
              title="Título 2"
              @click="commands.heading({ level: 2 })"
            >H2</v-btn>

            <v-btn
              flat
              small
              outline
              icon
              class="control__text"
              :class="{ 'is-active accent': isActive.heading({ level: 3 }) }"
              title="Título 3"
              @click="commands.heading({ level: 3 })"
            >H3</v-btn>

            <!-- <v-btn
              flat
              small
              outline
              icon
              class="control__text"
              :class="{ 'is-active accent': isActive.bullet_list() }"
              title="Borrar formato"
              @click="commands.bullet_list"
            >
              <v-icon>format_list_bulleted</v-icon>
            </v-btn> -->

            <!-- <v-btn
              flat
              small
              outline
              icon
              class="control__text"
              :class="{ 'is-active accent': isActive.ordered_list() }"
              title="Borrar formato"
              @click="commands.ordered_list"
            >
              <v-icon>format_list_numbered</v-icon>
            </v-btn> -->

            <!-- <v-btn
              flat
              small
              outline
              icon
              class="control__text"
              :class="{ 'is-active accent': isActive.blockquote() }"
              title="Borrar formato"
              @click="commands.blockquote"
            >
              <v-icon>format_quote</v-icon>
            </v-btn> -->

            <!-- <v-btn
              flat
              small
              outline
              icon
              class="control__text"
              :class="{ 'is-active accent': isActive.code_block() }"
              title="Bloque de código"
              @click="commands.code_block"
            >
              <v-icon>code</v-icon>
            </v-btn> -->

            <!-- <v-btn
              flat
              small
              outline
              icon
              class="control__text"
              title="Bloque de código"
              @click="showImagePrompt(commands.image)"
            >
              <v-icon>add_photo_alternate</v-icon>
            </v-btn> -->

            <!-- <v-btn
              flat
              small
              outline
              icon
              class="control__text"
              title="Línea horizontal"
              @click="commands.horizontal_rule"
            >
              <v-icon>remove</v-icon>
            </v-btn> -->

            <v-btn
              flat
              small
              outline
              icon
              class="control__text"
              title="Línea horizontal"
              @click="commands.undo"
            >
              <v-icon>undo</v-icon>
            </v-btn>

            <v-btn
              flat
              small
              outline
              icon
              class="control__text"
              title="Línea horizontal"
              @click="commands.redo"
            >
              <v-icon>redo</v-icon>
            </v-btn>

            <!-- </div> -->
          </v-toolbar>
        </editor-menu-bar>
      </v-card-title>
      
      <v-card-text class="mb-4">      
        <editor-content class="editor" :editor="editor"/>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
// import Icon from 'Components/Icon'
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  Image,
  Placeholder,
} from 'tiptap-extensions'
import { bus } from "./../../main";
export default {
    name: 'Editor',
    components: {
        EditorContent,
        EditorMenuBar,
        // Icon,
    },
    props: ['value', 'title', 'extraclass', 'dark', 'icon'],
    mounted() {
      bus.$on("getEditorContent", ()=> { 
        //console.log('bus get content') 
        this.getContent() 
      })
      this.initEditor()
    },
    data() {
      return {
        editor: null,
        }
    },
    methods: {
      initEditor () { //console.log('contentHTML', contentHTML, typeof this.editor, this.editor)
        
        if (this.editor) {
          this.editor.destroy()
        }

        this.editor = new Editor({
          extensions: [
            new Blockquote(),
            new BulletList(),
            new CodeBlock(),
            new HardBreak(),
            new Heading({ levels: [1, 2, 3] }),
            new HorizontalRule(),
            new ListItem(),
            new OrderedList(),
            new TodoItem(),
            new TodoList(),
            new Bold(),
            new Code(),
            new Italic(),
            new Link(),
            new Strike(),
            new Underline(),
            new History(),
            new Image(),
            new Placeholder({
              emptyClass: 'is-empty',
              emptyNodeText: 'Escriba los '+this.title.toLowerCase() +' aquí …',
              showOnlyWhenEditable: true,
            }),
          ],
          content: this.value,
          //onBlur: ({ event,  state, view }) => {
            //console.log('onBlur', event.target.innerHTML)
            //this.$emit('input', event.target.innerHTML) 
          //},
          //onUpdate: context => {
            //console.log('onUpdate', context.getHTML())
            //this.$emit('input', context.getHTML()) 
          //}
        })
      },
      showImagePrompt(command) {
        const src = prompt('Ingrese la URL de la imagen aquí.')
        if (src !== null) {
          command({ src })
        }
      },
      getContent() { //console.log('getContent')
        //console.log('updateContent', val.getHTML())
        this.$emit('input', this.editor.getHTML());
      }
    },
    watch: {
      value(val) {
        this.editor.setContent(val)
      }
    }
}
</script>

<style lang="scss" scope>
  .v-editor {
    .menubar .v-toolbar__content > :first-child.v-btn--icon, 
    .menubar .v-toolbar__extension > :first-child.v-btn--icon {
      margin-left: 6px;
    }
    .menubar .v-toolbar__content {
      height: auto !important;
      flex-flow: row wrap;
      justify-content: flex-start;
      padding: 1rem 0;
      /* flex-wrap: wrap !important; */
      .v-btn.accent {
        border-color: #2196f3 !important;
      }
    }
    .control__text {
      /* border: solid 1px #000; */
      border-radius: inherit !important;
    }

    .v-card {
      &.theme--dark {
        background-color:  #BBDEFB !important;//var(--v-secondary-color);
        color: rgba(0,0,0,.87);//#2196f3 !important;//var(--v-primary-color);
      }
    }
    .editor {
      background-color: #ffffff;
      .ProseMirror {
        min-height: 5rem;
        padding: 1rem;
        p {
          margin-bottom: 0;//.5rem;
          &.is-empty {
            &:first-child {
              &::before {
                content: attr(data-empty-text);
                float: left;
                color: rgba(0,0,0,.54);
                pointer-events: none;
                height: 20px;
                line-height: 20px;
                font-size: 16px;
              }
            }
          }
        }
      }      
    }
  }
</style>